import React from 'react';
import * as S from './PopupUI.styles';

type popupProps = {
  title?: string;
  content?: any;
  onCloseClick?:any;
  size ?: string;
};

const Popup = ({ title=' ', content,onCloseClick, size='large' }: popupProps) => (
  <S.PopupBackground>
    <S.Popup className={size}>
      <S.PopupHeader>
        {title}
        <S.PopupClose onClick={onCloseClick}>
          <span>X</span>
        </S.PopupClose>
        
      </S.PopupHeader>
      <S.PopupContent>{content}</S.PopupContent>
    </S.Popup>
  </S.PopupBackground>
);

export default Popup;
